import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-pcs7-sw-maintenance-contract',
  templateUrl: './pcs7-sw-maintenance-contract.component.html'
})
export class Pcs7SwMaintenanceContractComponent {
  @Input()
  public parentForm!: FormGroup;

  @Output()
  openHelpModal: EventEmitter<any> = new EventEmitter();

  constructor() {}
}
